<mat-card class="viewerholder">
    <div class="docheader">     
      <div class="name">{{ documentName }}</div>
      <div class="right_pannel">
        <div class="head">

          <ng-container *ngIf="showLocalPanel">
            <button mat-icon-button color="primary">
              <mat-icon>cloud_download</mat-icon>
            </button>
            <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>
          </ng-container>  
          <button mat-stroked-button matTooltip="Download" (click)="DownloadFile()"
          matTooltipClass="tooltip" color="primary">
          <!-- <mat-icon>cloud_download</mat-icon> -->
           Download
        </button>    
          <button mat-mini-fab class="ml-10"  color="warn" (click)="CloseDocumentViewer(CloseViewDocument)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  
    <div class="tophead">
      <button mat-flat-button class="name" (click)="opendocdetail()">
        <mat-icon color="primary" >menu</mat-icon> Detail
      </button>
    </div>
  
    <div class="docdetail">
      <div class="left_pannel" [ngClass]="{ open: showDetail }">  
        <mat-tab-group (selectedTabChange)="onTabClick($event)">          
          <mat-tab label="DETAIL">   
            <div class="detail">
              <form [formGroup]="myFormGroupDetails">
              <div class="info meta">
                <p><span>Doc Name</span>{{ documentName }}</p>
                <p><span>File Type</span>{{ documentType }}</p>
                <p *ngIf="fileSize"><span>Size</span>{{ fileSize }}</p>
                <p *ngIf="createdOn">
                  <span>Upload Date</span>{{ createdOn+'Z' | date: "MM/dd/yyyy" }}
                </p>
                <p >
                  <span>Upload By</span>{{ uploadedBy }}
                </p>                
                <p *ngIf="createdOn">
                  <span>Created Date</span>{{ createdOn+'Z' | date: "MM/dd/yyyy" }}
                </p>
              </div>           
              <div class="history">
                <div class="title">
                  <div class="head">
                    <h3>Description</h3>
                  </div>
                </div>
                <mat-form-field class="example-full-width">                
                  <!-- <mat-label>Description</mat-label> -->
                  <textarea matInput [(ngModel)]="documentdetails.description"  formControlName="description"></textarea>
                </mat-form-field>
              </div>
      
              <div class="history">
                <div class="title">
                  <div class="head">
                    <h3>Add Tag</h3>
                  </div>
                </div>
      
                <mat-form-field class="example-chip-list">
                  <mat-chip-list #chipList aria-label="Tag selection">
                    <mat-chip
                      *ngFor="let tag of tags"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="remove1(tag)">
                      {{ tag }}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                    
                      #tagInput
                      [formControl]="tagCtrl"
                      [matAutocomplete]="auto"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="add1($event)"
                    />
                  </mat-chip-list>
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="selected1($event)">
                    <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
                      {{ tag }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </form>

            <!-- <div class="actionBtn">
              <button
                mat-flat-button color="primary" type="submit"
                [disabled]="myFormGroupDetails.invalid || !myFormGroupDetails.dirty"
                (click)="UpdateDocumentDetails(myFormGroupDetails.value)">
                Save
                <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
                </mat-spinner></mat-icon>
              </button>
            </div> -->

              <div  *ngIf="fileFoldeTypeId==2">
      
                <!-- <div class="fullw"> -->
                  <mat-form-field>
                    <mat-label>Document Type</mat-label>
                       <mat-select [(ngModel)]="TypeIdDrp" (selectionChange)="onDocumentTypeChange($event)">
                         <mat-option *ngFor="let data of documentTypeList" [value]="data.documentTypeID">
                         {{data.documentTypeName}}
                        </mat-option>
                    </mat-select>
                  </mat-form-field>
                <!-- </div> -->
    
                <form [formGroup]="myFormGroup" class="fullw">
                    
        
                  <ng-container *ngFor="let field of coreUserList">
                    <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder"
                      [ngSwitch]="field.fieldTypeName">
                      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{field.data[0].groupName}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let grpField of field.data">
        
                          <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                            <ng-container *ngSwitchCase="'Textbox'">
                              <ng-container *ngIf="grpField.fieldName == 'Name'">
                                <mat-form-field>
                                  <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}"
                                    [(ngModel)]="transactionUserName" formControlName="{{ grpField.fieldName }}"
                                    [readonly]="grpField.rolePermission==1" />
        
        
                                </mat-form-field>
                              </ng-container>
        
                              <ng-container *ngIf="grpField.fieldName != 'Name'">
                                <ng-container *ngIf="grpField.fieldNames.length > 0">
                                  <div class="multipleBlock">
                                    <div class="multype">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{ grpField.fieldName + 'option' }}"
                                          placeholder="{{ grpField.placeholderVal }}">
                                          <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                            {{ names.fieldName }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field>
                                        <input [required]="grpField.isRequired" *ngIf="grpField.fieldName == 'Phone'" matInput
                                          placeholder="Add Phone" [(ngModel)]="grpField.fieldValue"
                                          formControlName="{{ grpField.fieldName }}" mask="(000) 000-0000"
                                          [readonly]="grpField.rolePermission==1" />
                                        <input [required]="grpField.isRequired" *ngIf="grpField.fieldName != 'Phone'" matInput
                                          placeholder="Add {{ grpField.placeholder }}" [(ngModel)]="grpField.fieldValue"
                                          formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                      </mat-form-field>
        
                                      <div class="inOline" *ngIf="grpField.fieldName == 'Address'">
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number"
                                              matInput (input)="searchCity($event.target.value)" formControlName="City"
                                              [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                            <mat-autocomplete #auto="matAutocomplete">
                                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <mat-select [disabled]="grpField.rolePermission==1" [(ngModel)]="stateValue"
                                              formControlName="State" placeholder="State">
                                              <mat-option>None</mat-option>
                                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <input type="text" placeholder="Zip Code" aria-label="Number" [(ngModel)]="zipValue"
                                              matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                              [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                            <mat-autocomplete #ZipCode="matAutocomplete">
                                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
        
        
                                      </div>
        
        
                                    </div>
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
        
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
                                    <div class="multype" *ngFor="let element of dynamicArray; let i = index">
        
        
                                      <div class="primaryEmail">
                                        <mat-form-field class="mulDropdown" appearance="">
                                          <mat-select (selectionChange)="clearPlaceholder($event)"
                                            formControlName="{{element.fieldName + 'option'}}"
                                            placeholder="{{ element.placeholderVal }}">
                                            <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of element.fieldNames;
                                                trackby: fieldNameID">{{ names.fieldName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
        
                                        <!-- <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
        
                                      </div>
        
                                      <mat-form-field>
                                        <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                          formControlName="{{ element.fieldName}}" [readonly]="grpField.rolePermission==1"
                                          pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                                      </mat-form-field>
        
                                    </div>
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
        
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                                    <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                            element.fieldName  + 'option'
                                          }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            ">{{ names.fieldName }}</mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field>
                                        <input matInput mask="(000) 000-0000" [(ngModel)]="element.fieldValue"
                                          placeholder="Add Phone" formControlName="{{ element.fieldName }}"
                                          [readonly]="grpField.rolePermission==1" />
                                      </mat-form-field>
        
        
                                    </div>
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
        
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                                    <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{
                                            element.fieldName + 'option'
                                          }}" placeholder="{{ element.placeholderVal }}">
                                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            ">{{ names.fieldName }}</mat-option>
                                        </mat-select>
                                      </mat-form-field>
        
                                      <mat-form-field>
                                        <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                          formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                      </mat-form-field>
        
                                      <div *ngIf="element.address.length>0" class="inOline">
                                        <ng-container *ngFor=" let adr of element.address;">
        
        
                                          <!-- <div class="divide">
                                          <mat-form-field> -->
                                          <input *ngIf="adr.childFieldType==3" placeholder="City" aria-label="Number" matInput
                                            [ngModel]="adr.fieldValue" (input)="searchCity($event.target.value)"
                                            formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                            [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of cityOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                          <!-- </mat-form-field>
                                        </div> -->
        
                                          <!-- <div class="divide">
                                          <mat-form-field> -->
                                          <mat-select [disabled]="grpField.rolePermission==1" [ngModel]="adr.fieldValue"
                                            *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}"
                                            placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                          <!-- </mat-form-field>
                                        </div> -->
        
        
                                          <!-- <div class="divide">
                                          <mat-form-field> -->
                                          <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                            aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                            formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                            [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #ZipCode="matAutocomplete">
                                            <mat-option *ngFor="let option of zipOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                          <!-- </mat-form-field>
                                        </div> -->
        
        
                                        </ng-container>
                                      </div>
                                      <div *ngIf="element.address.length==0" class="inOline">
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <input placeholder="City" aria-label="Number" matInput
                                              (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                              [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                            <mat-autocomplete #auto="matAutocomplete">
                                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <mat-select [disabled]="grpField.rolePermission==1"
                                              formControlName="State{{ (i + 1) }}" placeholder="State">
                                              <mat-option>None</mat-option>
                                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
        
                                        <div class="divide">
                                          <mat-form-field>
                                            <input placeholder="Zip Code" aria-label="Number" matInput
                                              (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                              [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                            <mat-autocomplete #ZipCode="matAutocomplete">
                                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
        
        
        
        
                                      </div>
        
                                    </div>
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
        
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                                    <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                            element.fieldName + 'option'
                                          }}">
                                          <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            ">{{ names.fieldName }}</mat-option>
                                        </mat-select>
                                      </mat-form-field>
        
        
                                      <mat-form-field>
                                        <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                          formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                      </mat-form-field>
        
        
                                    </div>
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
                                </ng-container>
        
                                <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                                  <mat-label>{{ grpField.fieldName }}</mat-label>
                                  <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}"
                                    formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                </mat-form-field>
                              </ng-container>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Textarea'">
                              <mat-form-field>
                                <textarea [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1">
                                </textarea>
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Number'">
                              <mat-form-field>
                                <input [required]="grpField.isRequired" matInput (keypress)="numberOnly($event)"
                                  placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                                  [readonly]="grpField.rolePermission==1" />
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Currency'">
                              <mat-form-field>
                                <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Address'">
                              <mat-form-field>
                                <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Image'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <div class="pic">
                                <input type="file" placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" (change)="onSelectFile($event)"
                                  [readonly]="grpField.rolePermission==1" />
                                <span class="ico">
                                  <mat-icon>add_a_photo</mat-icon>
                                </span>
                              </div>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Date'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <input [required]="grpField.isRequired" matInput [matDatepicker]="basicDatepicker"
                                  placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                                  [readonly]="grpField.rolePermission==1" />
                                <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #basicDatepicker></mat-datepicker>
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'URL'">
                              <mat-form-field>
                                <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'Dropdown'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled]="grpField.rolePermission==1"
                                  [ngModel]="getddlSelectedVal(grpField.fieldName)" [required]="grpField.isRequired"
                                  formControlName="{{ grpField.fieldName }}">
                                  <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                                    {{ drp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container>
        
                            <ng-container *ngSwitchCase="'MultiSelect'">
                              <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                                  <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                                    (removed)="remove(tag)">
                                    {{tag}}
                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                  </mat-chip>
                                  <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="add($event)">
                                </mat-chip-list>
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                  <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                                    {{tag}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
        
                              <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled]="grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                                  [ngModel]="getMultiddlSelectedVal(grpField.fieldName)"
                                  formControlName="{{ grpField.fieldName }}">
                                  <mat-option *ngFor="
                                      let muldrp of getMuldropdownlist(grpField.fieldName)
                                    " [value]="muldrp">
                                    {{ muldrp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
        
                            </ng-container>
        
                            <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                                [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" multiple formControlName="{{ grpField.fieldName }}">
                                  <mat-option
                                    *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                                    [value]="muldrp">
                                    {{ muldrp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container> -->
        
                            <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName ==='Tags'">
                              <mat-form-field class="example-chip-list">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                                  <mat-chip
                                    *ngFor="let fruit of filteredFruits"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="remove(fruit)">
                                    {{fruit}}
                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                  </mat-chip>
                                  <input
                                    placeholder="Add Tags"
                                    #fruitInput
                                    [formControl]="fruitCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="add($event)"
                                    [readonly] = "grpField.rolePermission==1">
                                </mat-chip-list>
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                  <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                                    {{fruit}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </ng-container>                     -->
        
        
                            <ng-container *ngSwitchCase="'Checkbox'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <ul class="check">
                                <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                                  <mat-checkbox color="primary" [disabled]="grpField.rolePermission==1"
                                    [checked]="isChecked(grpField.fieldName, chk)"
                                    (change)="OnChange($event, chk, grpField.fieldID)">
                                    {{ chk }}
                                  </mat-checkbox>
                                </li>
                              </ul>
                            </ng-container>
        
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
        
                    <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID > 0">
        
                      <div *ngSwitchCase="'Textbox'">
        
                        <!-- <ng-container *ngIf="field.fieldNames.length > 0">
                          <ng-container>
                            <div class="multipleBlock">
                              <div class="multype">
                               
                                <div class="forAddress">
                                 
                                  <mat-form-field class="mulDropdown" appearance="">
                                    <mat-select [ngModel]="field.fieldNameID" formControlName="{{ field.fieldName + 'option' }}">
                                      <mat-option [value]="names.fieldNameID" *ngFor="
                                          let names of field.fieldNames;
                                          trackby: fieldNameID
                                        ">{{ names.fieldName }}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                
        
                                </div>
                                <mat-form-field>
                                  <input [required]='field.isRequired' *ngIf="field.fieldName == 'Phone'" matInput
                                    placeholder="Add Phone" [(ngModel)]="field.fieldValue"
                                    formControlName="{{ field.fieldName }}" mask="(000) 000-0000"
                                    [readonly]="field.rolePermission==1" />
                                  <input [required]='field.isRequired' *ngIf="field.fieldName == 'Email'" matInput
                                    placeholder="Add Email" [(ngModel)]="field.fieldValue"
                                    formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                                  <input [required]='field.isRequired' *ngIf="field.fieldName == 'Address'" matInput
                                    placeholder="Add Address" [(ngModel)]="field.fieldValue"
                                    formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
        
                                    <div class="" *ngIf="field.fieldName == 'Address'">
        
          
                                      <button mat-icon-button color="primary" class="addressPin" (click)="showLocationOnMap(field.fieldValue)">
                                        <mat-icon>pin_drop</mat-icon>
                                      </button> 
              
                                    </div>
        
        
                                </mat-form-field>
        
                                
                                <div *ngIf="field.fieldName == 'Address'" class="inOline">
        
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number" matInput
                                        (input)="searchCity($event.target.value)" formControlName="City"
                                        [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of cityOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
        
                                  <div class="divide">
                                    <mat-form-field>
        
                                      <mat-select [disabled]="field.rolePermission==1" [(ngModel)]="stateValue"
                                        formControlName="State" placeholder="State">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
        
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number"
                                        matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                        [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                      <mat-autocomplete #ZipCode="matAutocomplete">
                                        <mat-option *ngFor="let option of zipOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
        
        
        
        
                                </div>
                               
        
                              </div>
                              <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                                Add more
                              </span>
                            </div>
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                              <div class="multype" *ngFor="let element of dynamicArray; let i = index">
        
                                <div class="primaryEmail">
        
                                  <mat-form-field class="mulDropdown" appearance="">
                                    <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                      formControlName="{{ element.fieldName + 'option' }}"
                                      placeholder="{{ element.placeholderVal }}">
                                      <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                          let names of element.fieldNames;
                                          trackby: fieldNameID
                                        ">{{ names.fieldName }}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
        
                                
                                </div>
        
                                <mat-form-field>
                                  <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1"
                                    pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                                </mat-form-field>
        
                              </div>
                              <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                                Add more
                              </span>
                            </div>
        
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                              <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ element.fieldName + 'option' }}"
                                    placeholder="{{ element.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
        
                                <mat-form-field>
                                  <input matInput placeholder="Add Phone" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName }}" mask="(000) 000-0000"
                                    [readonly]="field.rolePermission==1" />
                                </mat-form-field>
        
        
        
                              </div>
                              <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                                Add more
                              </span>
                            </div>
        
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                              <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ element.fieldName + 'option' }}"
                                    placeholder="{{ element.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
        
                                <mat-form-field>
                                  <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1" />
                                </mat-form-field>
        
                                <div *ngIf="element.address.length>0" class="inOline">
                                  <ng-container *ngFor=" let adr of element.address;">
        
        
                                   
                                    <input *ngIf="adr.childFieldType==3" placeholder="City" [ngModel]="adr.fieldValue"
                                      aria-label="Number" matInput (input)="searchCity($event.target.value)"
                                      formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                      [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let option of cityOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  
                                    <mat-select [disabled]="field.rolePermission==1" [ngModel]="adr.fieldValue"
                                      *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}" placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                   
                                    <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                      aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                      formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                      [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #ZipCode="matAutocomplete">
                                      <mat-option *ngFor="let option of zipOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                   
        
                                  </ng-container>
        
                                </div>
                                <div *ngIf="element.address.length==0" class="inOline">
        
        
        
                                  <div class="divide">
                                    <mat-form-field>
                                      <input placeholder="City" aria-label="Number" matInput
                                        (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                        [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of cityOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
        
        
                                  <div class="divide">
                                    <mat-form-field>
                                      <mat-select [disabled]="field.rolePermission==1" formControlName="State{{ (i + 1) }}"
                                        placeholder="State">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
        
        
                                  <div class="divide">
                                    <mat-form-field>
                                      <input placeholder="Zip Code" aria-label="Number" matInput
                                        (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                        [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                      <mat-autocomplete #ZipCode="matAutocomplete">
                                        <mat-option *ngFor="let option of zipOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
        
        
        
        
                                </div>
        
        
                              </div>
                              <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                                Add more
                              </span>
                            </div>
        
                            <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                              <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{
                                      element.fieldName + 'option'
                                    }}" placeholder="{{ element.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
        
                                <mat-form-field>
                                  <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="field.rolePermission==1" />
                                </mat-form-field>
        
        
        
                              </div>
                              <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                                Add more
                              </span>
                            </div>
                          </ng-container>
                        </ng-container> -->
        
                        <!-- <mat-form-field *ngIf="field.fieldName == 'Name'">
                          <input matInput [required]="field.isRequired" [(ngModel)]="transactionUserName"
                            placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                          <mat-error *ngIf="
                              myFormGroup.get(field.fieldName).invalid &&
                              (myFormGroup.get(field.fieldName).dirty ||
                                myFormGroup.get(field.fieldName).touched)
                            ">
                            <span *ngIf="myFormGroup.get(field.fieldName).errors.required">This field is mandatory.</span>
                          </mat-error>
                        </mat-form-field> -->
        
                        <mat-form-field *ngIf="field.fieldName != 'Name'">
        
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                        </mat-form-field>
        
                      </div>
        
                      <div *ngSwitchCase="'Textarea'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <textarea [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1"></textarea>
                        </mat-form-field>
                      </div>
        
                      <div *ngSwitchCase="'Number'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput (keypress)="numberOnly($event)"
                            placeholder="{{ field.fieldName }}" [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                        </mat-form-field>
                      </div>
        
                      <div *ngSwitchCase="'Currency'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                            [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                        </mat-form-field>
                      </div>
        
                      <div *ngSwitchCase="'Address'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                            [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                        </mat-form-field>
                      </div>
        
                      <div *ngSwitchCase="'URL'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                        </mat-form-field>
                      </div>
        
                      <div *ngSwitchCase="'Date'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired' matInput [matDatepicker]="basicDatepicker"
                            [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                            [readonly]="field.rolePermission==1" />
                            <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
                          <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                          <mat-datepicker #basicDatepicker></mat-datepicker>
                        </mat-form-field>
                      </div>
        
        
        
                      <ng-container *ngSwitchCase="'Dropdown'">
                        <mat-form-field *ngIf="field.fieldName == 'Type'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"
                            formControlName="{{ field.fieldName }}"
                            (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                            <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                              {{typelist.folderName}}
                            </mat-option>
                          </mat-select>
        
                        </mat-form-field>
        
                        <mat-form-field *ngIf="field.fieldName != 'Type'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' [ngModel]="getddlSelectedVal(field.fieldName)"
                            formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                            <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                              {{ drp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
        
        
                      <ng-container *ngSwitchCase="'MultiSelect'">
        
                        <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                            <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                              (removed)="remove(tag)">
                              {{tag}}
                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              (matChipInputTokenEnd)="add($event)">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                              {{tag}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
        
                        <mat-form-field *ngIf="field.fieldName != 'Tags'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
                            formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                            <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                              {{ muldrp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
        
        
                      <ng-container *ngSwitchCase="'Checkbox'">
                        <div class="checkList">
                          <mat-label>{{ field.fieldName }}</mat-label>
        
                          <div class="allCheckList" *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                            <mat-checkbox color="primary" [disabled]="field.rolePermission==1"
                              [checked]="isChecked(field.fieldName, chk)" (change)="OnChange($event, chk, field.fieldID)">
                              {{ chk }}
                            </mat-checkbox>
                          </div>
                        </div>
                      </ng-container>
        
                    </div>
                  </ng-container>
        
                  <div class="actionBtn">
                    
                    <button mat-flat-button class="calltoaction" type="submit"             
                    (click)="onSubmit(myFormGroup.value, myFormGroup)" color="primary">
                      Save
                      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
                      </mat-spinner></mat-icon>
                    </button>
                  </div>
                </form>
              </div>

            </div>   
            

            
            
          </mat-tab>  
          <mat-tab label="AI DATA">
            <!-- <div class="info meta"  *ngFor="let docData of documentData;let i = index">
              <p><span>{{docData.Key}}</span>{{docData.Value}}</p>
            </div>
            <div *ngIf="documentData==null">
              <p class="info meta"> </p>
              <p class="notFound"> No Record Found, may be this document not processed with AI Service.</p>
            </div> -->

            <div class="info meta aiTab"  >
              <p *ngFor="let docData of documentData;let i = index" ><span>{{docData.Key}}</span>{{docData.Value}}</p>
              <div *ngIf="documentData==null">
                <p class="notFound"> No Record Found, may be this document not processed with AI Service.</p>
              </div>
            </div>
            
          </mat-tab>

          <mat-tab label="ACTIVITY" >
            <div class="touches_holder">
              <div class="addtouch">
                <button mat-stroked-button color="primary" (click)="addTouch()" ><mat-icon>add</mat-icon> Add Activity</button>
              </div>
      
              <div class="touches" *ngFor="let touch of AllCoreTouchesList">
                <h4 class="">
                  <mat-icon class="note" *ngIf="touch.touchTypeName=='Note'">event_note</mat-icon>
                  <mat-icon class="call" *ngIf="touch.touchTypeName=='Phone Call'">local_phone</mat-icon>
                  <mat-icon class="email" *ngIf="touch.touchTypeName=='Email'">mail</mat-icon>
                  <mat-icon class="meeting" *ngIf="touch.touchTypeName=='Meeting'">recent_actors</mat-icon>
                  <mat-icon class="others" *ngIf="touch.touchTypeName=='Other'">add_to_photos</mat-icon>
                  <mat-icon class="others" *ngIf="touch.touchTypeName=='Log'">text_snippet</mat-icon>
                  <mat-icon *ngIf="touch.touchTypeName != 'Note' && touch.touchTypeName != 'Phone Call' && touch.touchTypeName != 'Email' && touch.touchTypeName != 'Meeting'
                    && touch.touchTypeName != 'Other' && touch.touchTypeName != 'Log'">touch_app</mat-icon>
              
                  <span> {{touch.createdByFirstName|titlecase}} {{touch.createdByLastName|titlecase}}
                    added {{touch.touchTypeName}} on {{touch.createdOn+'Z' | date:'MM/dd/yyyy'}} - {{touch.touchStatusName}}</span>
              
                </h4>
              
                <div class="timeStamp">
              
              
                  <div class="time">
                    <span *ngIf="touch.startDate != null"> {{touch.startDate+'Z' | date:'MM/dd/yyyy'}}</span>
                    <span *ngIf="touch.touchDate != null"> {{touch.touchDate+'Z' | date:'MM/dd/yyyy'}}</span>
                    <span *ngIf="touch.startTime != null || touch.touchTime != null" class="sep">-</span>
                    <span *ngIf="touch.startTime != null"> {{touch.startTime | date:'h:mm a'}} </span>
                    <span *ngIf="touch.touchTime != null"> {{touch.touchTime | date:'h:mm a'}} </span>
                  </div>               
                  <p>
                    {{ touch.touchNote }}
                  </p>  
                </div>
              </div>
            </div>
          </mat-tab> 

        </mat-tab-group> 
        
      </div>
  
      <div class="viewer">
        <ngx-doc-viewer *ngIf="documentType == 'doc' ||
            documentType == 'txt' ||
            documentType == 'docx' ||
            documentType == 'ppt' ||
            documentType == 'pptx' ||
            documentType == 'xlsx' ||
            documentType == 'csv' ||
            documentType == 'xls'" 
            [url]="documentpath"
            viewer="google"
            width="100%"
            height="100%">
        </ngx-doc-viewer>

        <ngx-doc-viewer
           *ngIf="documentType == 'pdf'"
            [url]="documentpath"
            viewer="url"
            width="100%"
            height="100%">
        </ngx-doc-viewer>

        <div class="imgPreviewerDoc"
        *ngIf="documentType == 'jpeg' ||
        documentType == 'jpg' ||
        documentType == 'png' ||
        documentType == 'gif' ||
        documentType == 'gif'"
        > 
        <img src="{{documentpath}}" >
  
        </div>
        <div class="imgPreviewerDoc"
        *ngIf="documentType == 'heic'"> 
        <img src="{{selectedImagetoShow}}" > 
        </div>
     
    </div>
  
      <div class="lefoverlay" (click)="opendocdetail()" [ngClass]="{ open: showDetail }"></div>
    </div>
  </mat-card>
  
  <div class="overlay" (click)="CloseDocumentViewer(CloseViewDocument)"></div>
  <app-loader></app-loader>

  